import { useSelector } from "react-redux";
import Product from "../Components/Product";

const Products = () => {
	const products = useSelector((state) => state);

	return (
		<div className="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-8 xxl:col-span-8">
			{products.map((product) => (
				<Product
					key={product.id}
					id={product.id}
					title={product.title}
					price={product.price}
					quantity={product.quantity}
				/>
			))}
		</div>
	);
};

export default Products;
